import { render, staticRenderFns } from "./footerTop.vue?vue&type=template&id=c5916daa"
import script from "./footerTop.vue?vue&type=script&lang=js"
export * from "./footerTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports